module.exports = __webpack_public_path__ + "img/industry-banner-crm-01.904e17d5.png";